/** <option>s a partir de pares [valor, rótulo]. */
export function Options({ items }: { items: readonly (readonly [string | number, string])[] }) {
  return <>{items.map(([v, t]) => <option key={String(v)} value={v}>{t}</option>)}</>;
}
